import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export interface User {
  id: string;
  username: string;
  role: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserRequest {
  username: string;
  password: string;
  role?: string;
  isActive?: boolean;
}

export interface UpdateUserRequest {
  username?: string;
  password?: string;
  role?: string;
  isActive?: boolean;
}

class UserService {
  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getAllUsers(): Promise<User[]> {
    const response = await axios.get(`${API_BASE_URL}/users`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async getUserById(id: string): Promise<User> {
    const response = await axios.get(`${API_BASE_URL}/users/${id}`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async createUser(userData: CreateUserRequest): Promise<User> {
    const response = await axios.post(`${API_BASE_URL}/users`, userData, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async updateUser(id: string, userData: UpdateUserRequest): Promise<User> {
    const response = await axios.put(`${API_BASE_URL}/users/${id}`, userData, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async deleteUser(id: string): Promise<{ message: string }> {
    const response = await axios.delete(`${API_BASE_URL}/users/${id}`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async toggleUserStatus(id: string): Promise<User> {
    const response = await axios.put(`${API_BASE_URL}/users/${id}/toggle-status`, {}, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }
}

export const userService = new UserService();
